__turbopack_context__.v({
  "button": "AriaSelect-module__ds2hZG__button",
  "fieldError": "AriaSelect-module__ds2hZG__fieldError",
  "legacy": "AriaSelect-module__ds2hZG__legacy",
  "legacyButton": "AriaSelect-module__ds2hZG__legacyButton",
  "listBox": "AriaSelect-module__ds2hZG__listBox",
  "listBoxItem": "AriaSelect-module__ds2hZG__listBoxItem",
  "pill": "AriaSelect-module__ds2hZG__pill",
  "popover": "AriaSelect-module__ds2hZG__popover",
  "select": "AriaSelect-module__ds2hZG__select",
  "selectIcon": "AriaSelect-module__ds2hZG__selectIcon",
  "selectValue": "AriaSelect-module__ds2hZG__selectValue",
  "title": "AriaSelect-module__ds2hZG__title",
});
